import React, { Component } from 'react';
//import { Container, Row, Col } from 'react-bootstrap';
import { ReactComponent as LoadingImg } from '../images/loading.svg';

export class Loading extends Component {

  static defaultProps = {  
    loadingText: 'Loading...'  
  };  

  render () {
    return (
        <div id="loadingArea">
            <LoadingImg className="waitIcon" />
            {this.props.loadingText}  
        </div>
    );
  }
}
